"use strict";

exports.__esModule = true;
exports.Row = exports.RenderVirtualizedList = void 0;
var _react = _interopRequireDefault(require("react"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _reactWindow = require("react-window");
var _helper = require("./helper");
var _RenderGroup = require("./RenderGroup");
var _RenderItem = require("./RenderItem");
var _excluded = ["items", "input", "handleSelect"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var getItemData = (0, _memoizeOne["default"])(function (items, input, query, props) {
  return Object.assign({
    items: items,
    input: input,
    query: query
  }, props);
});
var RenderVirtualizedList = exports.RenderVirtualizedList = function RenderVirtualizedList(props) {
  var items = props.items,
    height = props.height,
    input = props.input,
    query = props.query,
    renderItemText = props.renderItemText,
    renderItemLabel = props.renderItemLabel;
  var itemData = getItemData(items, input, query, props);
  var width = (0, _helper.useWidth)(renderItemText, renderItemLabel, items, 250);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "ItemList"
  }, /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
    height: height,
    width: width,
    itemData: itemData,
    itemCount: items.length,
    itemSize: 30
  }, Row));
};
var Row = exports.Row = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var data = _ref.data,
    index = _ref.index,
    style = _ref.style;
  var items = data.items,
    input = data.input,
    handleSelect = data.handleSelect,
    props = _objectWithoutPropertiesLoose(data, _excluded);
  var item = items[index];
  if (typeof item !== "object") {
    return /*#__PURE__*/_react["default"].createElement(_RenderItem.RenderItem, _extends({}, props, {
      item: item,
      input: input,
      handleSelect: handleSelect,
      style: style
    }));
  }
  var isGroup = item.isGroup;
  if (isGroup) {
    return /*#__PURE__*/_react["default"].createElement(_RenderGroup.RenderGroup, _extends({}, props, {
      input: input,
      groupItem: item,
      style: style,
      handleSelect: handleSelect
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_RenderItem.RenderItem, _extends({}, props, {
    item: item,
    input: input,
    handleSelect: handleSelect,
    style: style
  }));
});